<app-cookie-banner-display [cookieUrl]="cookieUrl">
</app-cookie-banner-display>
<app-header></app-header>
<main>
  <div class="main">
    <app-feature-wrapper
      [panelConfig]="panelConfig$ | async"
      [policyId]="policyId$ | async"
      [isProgressing]="isShowProgressBar$ | async"
      [policyChangeDate]="policyChangeDate$ | async"
      [journeyPath]="journeyPath$ | async">
    </app-feature-wrapper>
    <ng-container *ngIf="(!isEditPage) && ((((isAutoRenewal$ | async) && isInitialPage && isReviewSelected$ | async) || !isInitialPage))">
      <app-journey-navigation
        [panelConfig]="panelConfig$ | async"
        [navigationDetails]="navigationDetails$ | async"
        [isShowJourneyNav]="isShowJourneyNav$ | async">
      </app-journey-navigation>
    </ng-container>
  </div>
</main>
<app-footer></app-footer>
